import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, resolveComponent as _resolveComponent, vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, renderList as _renderList, createSlots as _createSlots, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-4f20c0f1"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "menu-title-style" };
const _hoisted_2 = { class: "menu-title-style" };
import path from "path";
import { useRoute } from "vue-router";
import { isExternal } from "@/utils";
import AppLink from "./Link.vue";
import { reactive, computed } from "vue";
export default /*#__PURE__*/ _defineComponent({
    name: 'SidebarItem',
    props: {
        item: { default: () => ({}) },
        basePath: { default: "" },
        activeMenu: { default: "" }
    },
    setup(__props) {
        const props = __props;
        const route = useRoute();
        let onlyOneChildValue = computed(() => onlyOneChild);
        const activeTitle = computed(() => {
            if (route.meta?.hasSubMenu) {
                return route?.matched[1]?.meta?.title;
            }
            return route?.matched[0]?.meta?.title;
        });
        const activeSubTitle = computed(() => {
            return route?.matched[0]?.meta?.title;
        });
        let onlyOneChild = reactive({});
        const hasOneShowingChild = (children = [], parent) => {
            if (parent.meta && parent.meta.alwaysShow) {
                return false;
            }
            const showingChildren = children.filter((item) => {
                if (item.hidden) {
                    return false;
                }
                else {
                    onlyOneChild = reactive(item);
                    return true;
                }
            });
            if (showingChildren.length === 1) {
                return true;
            }
            if (showingChildren.length === 0) {
                onlyOneChild = reactive({ ...parent, path: "", noShowingChildren: true });
                return true;
            }
            return false;
        };
        const resolvePath = (routePath) => {
            if (isExternal(routePath)) {
                return routePath;
            }
            if (isExternal(props.basePath)) {
                return props.basePath;
            }
            return path.resolve(props.basePath, routePath);
        };
        return (_ctx, _cache) => {
            const _component_svg_icon = _resolveComponent("svg-icon");
            const _component_el_menu_item = _resolveComponent("el-menu-item");
            const _component_sidebar_item = _resolveComponent("sidebar-item", true);
            const _component_el_sub_menu = _resolveComponent("el-sub-menu");
            return (!__props.item.hidden)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    (hasOneShowingChild(__props.item.children, __props.item) &&
                        (!_unref(onlyOneChild).children || _unref(onlyOneChild).noShowingChildren))
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            (_unref(onlyOneChildValue).meta)
                                ? (_openBlock(), _createBlock(AppLink, {
                                    key: 0,
                                    open: _unref(onlyOneChildValue).isOpen,
                                    external: _unref(onlyOneChildValue).meta.external,
                                    to: resolvePath(_unref(onlyOneChildValue).path)
                                }, {
                                    default: _withCtx(() => [
                                        _createVNode(_component_el_menu_item, {
                                            index: resolvePath(_unref(onlyOneChildValue).path),
                                            "popper-class": "my-popper"
                                        }, {
                                            title: _withCtx(() => [
                                                _createElementVNode("span", _hoisted_1, _toDisplayString(_unref(onlyOneChildValue).meta.title), 1)
                                            ]),
                                            default: _withCtx(() => [
                                                _withDirectives(_createVNode(_component_svg_icon, {
                                                    "icon-class": (_unref(activeTitle) === _unref(onlyOneChildValue).meta.title
                                                        ? _unref(onlyOneChildValue).meta.activeIcon
                                                        : _unref(onlyOneChildValue).meta.icon) || '',
                                                    "class-name": "menu-icon"
                                                }, null, 8, ["icon-class"]), [
                                                    [_vShow, _unref(onlyOneChildValue).meta.icon]
                                                ])
                                            ]),
                                            _: 1
                                        }, 8, ["index"])
                                    ]),
                                    _: 1
                                }, 8, ["open", "external", "to"]))
                                : _createCommentVNode("", true)
                        ], 64))
                        : (_openBlock(), _createBlock(_component_el_sub_menu, {
                            key: 1,
                            ref: "subMenu",
                            index: resolvePath(__props.item.path),
                            deprecated: "",
                            "popper-class": "my-popper"
                        }, _createSlots({
                            default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.item.children, (child) => {
                                    return (_openBlock(), _createBlock(_component_sidebar_item, {
                                        key: child.path,
                                        item: child,
                                        "base-path": resolvePath(child.path)
                                    }, null, 8, ["item", "base-path"]));
                                }), 128))
                            ]),
                            _: 2
                        }, [
                            (__props.item.meta)
                                ? {
                                    name: "title",
                                    fn: _withCtx(() => [
                                        (__props.item.meta && __props.item.meta.icon)
                                            ? (_openBlock(), _createBlock(_component_svg_icon, {
                                                key: 0,
                                                "icon-class": (_unref(activeSubTitle) === __props.item.meta.title
                                                    ? __props.item.meta.activeIcon
                                                    : __props.item.meta.icon) || '',
                                                "class-name": "menu-icon"
                                            }, null, 8, ["icon-class"]))
                                            : _createCommentVNode("", true),
                                        _createElementVNode("span", _hoisted_2, _toDisplayString(__props.item.meta.title), 1)
                                    ])
                                }
                                : undefined
                        ]), 1032, ["index"]))
                ], 64))
                : _createCommentVNode("", true);
        };
    }
});
